import React from "react";

const SvgLowBellGraph = (props) => (
  <svg width={90} height={55} {...props}>
    <defs>
      <filter
        x="-33.6%"
        y="-41.7%"
        width="167.1%"
        height="257.9%"
        filterUnits="objectBoundingBox"
        id="Low_Bell_Graph_svg__a"
      >
        <feMorphology
          radius={1.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset dy={12} in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feMorphology radius={1.5} in="SourceAlpha" result="shadowInner" />
        <feOffset dy={12} in="shadowInner" result="shadowInner" />
        <feComposite
          in="shadowOffsetOuter1"
          in2="shadowInner"
          operator="out"
          result="shadowOffsetOuter1"
        />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.470588235 0 0 0 0 0.564705882 0 0 0 0 0.611764706 0 0 0 0.243716033 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M69.809 28.702c-4.173-.92-7.272-2.327-9.298-4.22-3.039-2.842-7.455-16.25-15.126-21.306C37.714-1.88 31.651-1.68 23.81 9.538c-7.84 11.218-7.262 11.73-10.717 14.943C10.789 26.623 7.028 28.463 1.809 30"
        id="Low_Bell_Graph_svg__b"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#F7B500"
        opacity={0.209}
        d="M28.423 35.25l-19.392.6L9 30.999l2.577-.784h2.069l1.661-.358 1.683 1.142 2.811-2.505 2.818-1.784 2.59-5.5L29 16.85z"
      />
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(9 2)"
      >
        <use
          fill="#000"
          filter="url(#Low_Bell_Graph_svg__a)"
          xlinkHref="#Low_Bell_Graph_svg__b"
        />
        <use
          stroke="#FEB50B"
          strokeWidth={3}
          xlinkHref="#Low_Bell_Graph_svg__b"
        />
      </g>
    </g>
  </svg>
);

export default SvgLowBellGraph;
